import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { SharedModule } from 'app/shared';
import { NotificationsDropdownFooterComponent } from './notifications-dropdown-footer.component';
import { NotificationsDropdownHeaderComponent } from './notifications-dropdown-header.component';
import { NotificationsPreferencesComponent } from './notifications-preferences.component';


@Component({
    selector: 'notifications-dropdown-preferences',
    imports: [
        SharedModule,
        NotificationsDropdownHeaderComponent,
        NotificationsDropdownFooterComponent,
        NotificationsPreferencesComponent,
    ],
    styles: [
        `
            :host {
                display: flex;
                flex-direction: column;
                height: 100%;
            }
            .notifications-list-btn {
                color: #222729;
            }

            .font-size-larger {
                font-size: larger;
            }

            .notifications-list-btn-text:hover {
                color: #01549B;
            }

            .fa-chevron-left {
                font-size: large;
            }
        `,
    ],
    template: `
        <notifications-dropdown-header>
            Notification preferences
        </notifications-dropdown-header>
        <notifications-preferences
            class="flex-grow-1 flex-shrink-1 min-height-0"
            scrollable>
        </notifications-preferences>
        <notifications-dropdown-footer>
            <button
                class="btn btn-transparent notifications-list-btn font-size-larger"
                (click)="goToNotificationList()"
                tooltip="Go to Notifications list"
                tooltipPlacement="top">
                <i class="fa fa-chevron-left"></i>
                <span class="ml-2 notifications-list-btn-text">List of Notifications</span>
            </button>
        </notifications-dropdown-footer>
    `,
})
export class NotificationsDropdownPreferencesComponent {

    private router = inject(Router);

    goToNotificationList() {
        this.router.navigate([{ outlets: { notifications: 'list' } }]);
    }
}
